import { formatDollars } from '~/utils/formatNumber';
import { display } from '../../common';
import { UnitDecimals } from '~/constants';
import { Project } from '~/types/project';
import getDisplayValueCosts from './getDisiplayValueCosts';

export default function otherCosts(project: Project, type: 'interconnection' | 'otherItc' | 'otherNonItc', projectCosts: any) {
  const projectCostsData = getDisplayValueCosts(project, projectCosts);
  const { overall, perWdc: wdc, perKwh: kwh } = projectCostsData || {}; 

  const perKwh = display(kwh?.[type] && formatDollars(kwh[type], { dec: 2, default0: '' }));
  const perWdc = display(wdc?.[type] && formatDollars(wdc[type], { dec: UnitDecimals.WDC, default0: '' }));
  const total = display(overall?.[type] && formatDollars(overall[type], { dec: UnitDecimals.TOTAL, default0: '' }));

  return {
    perKwh,
    perWdc,
    total
  };
}